import { render, staticRenderFns } from "./EditCustomerProfileForm.vue?vue&type=template&id=936cdb3a&scoped=true"
import script from "./EditCustomerProfileForm.vue?vue&type=script&lang=js"
export * from "./EditCustomerProfileForm.vue?vue&type=script&lang=js"
import style0 from "./EditCustomerProfileForm.vue?vue&type=style&index=0&id=936cdb3a&prod&lang=scss&scoped=true"
import style1 from "./EditCustomerProfileForm.vue?vue&type=style&index=1&id=936cdb3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936cdb3a",
  null
  
)

export default component.exports